











import { DateUtils } from '@olbbank/vue-components';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { OlbIcon } from '@olbbank/vue-components';

export default defineComponent({
	components: {
		OlbIcon,
	},
	props: {
		seconds: {
			type: Number,
			default: 0,
		},
		large: {
			type: Boolean,
			default: false,
		},
		clockOnly: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const time = computed(() => {
			return DateUtils.formatSeconds(props.seconds);
		});
		const clockRef = ref<HTMLDivElement | null>(null);
		function clickHandler(event: Event): void {
			emit('click', event);
		}

		const variableClasses = computed(() => {
			const classes = [];
			// since the sticky header on landingpages is mint,
			// the clock background is white for better readability
			const isOnMintBg = clockRef?.value?.closest('.bg-mint');
			classes.push('bg-mint');

			// Neelmeyer has a different font which causes the navigation to move, when a digit is narrow (e.g. 1)
			const isNeelmeyer = document.querySelector('.l-neelmeyer');
			isNeelmeyer && classes.push('min-w-115');
			!props.clockOnly && classes.push('flex');
			return classes;
		});
		return {
			clickHandler,
			time,
			variableClasses,
			clockRef,
		};
	},
});
